import axios from '../axios-auth';
import orginal_axios from "axios";

export const regionService = {
    getRegionList,
    saveRegion,
    getRegion,
    getRegionsByStatus,
    getAllRegions,
    saveRegionExcel,
    getRegionExcelTemplate,
    getRegionExcelExport,
    getRegionDetailProduct,
    saveRegionDetail,
    deleteRegionDetail
}

function getRegionList(searchParams, page, size, sortedBy) {
    let params = {};
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    if (sortedBy == 'null,asc') {
        params["page"] = page;
        params["size"] = size;
    } else {
        params["page"] = page;
        params["size"] = size;
        params["sort"] = sortedBy;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return axios.get("/auth/region/", { params });
}

function saveRegion(region) {
    if (!region.id) {
        // new region
        return axios.post("/auth/region", region);
    } else {
        // edit
        return axios.put("/auth/region", region);
    }
}

function getRegionsByStatus(status) {
    return axios.get("/auth/region/region-by-status/" + status);
}

function getRegion(id) {
    return axios.get("/auth/region/" + id);
}

function getAllRegions() {
    return axios.get("/auth/region/all-region");
}

function getRegionExcelTemplate() {
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/region/region-excel-template",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function saveRegionExcel(file) {
    return axios.post('/auth/region/region-excel',
        file,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    )
}

function getRegionExcelExport(searchParams) {
    let params = {
    };
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/region/region-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function getRegionDetailProduct(searchParams, page, size, sortedBy) {
    let params = {};
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }
    if (sortedBy == 'null,asc') {
        params["page"] = page;
        params["size"] = size;
    } else {
        params["page"] = page;
        params["size"] = size;
        params["sort"] = sortedBy;
    }
    if (searchParams.productName) {
        params["productName"] = searchParams.productName;
    }
    if (searchParams.productCode) {
        params["productCode"] = searchParams.productCode;
    }
    if (searchParams.regionId) {
        params["regionId"] = searchParams.regionId;
    }
    return axios.get("/auth/region/all-product-by-region-id", { params });
}

function saveRegionDetail(detail) {
    if (!detail.id) {
        // new
        return axios.post("/auth/region/detail", detail);
    } else {
        // edit
        return axios.put("/auth/region/detail", detail);
    }
}

function deleteRegionDetail(regionDetail) {
    let params = {};
    params["id"] = regionDetail.regionId;
    params["productId"] = regionDetail.productId;
    params["productUnitId"] = regionDetail.productUnitId;
    return axios.delete("/auth/region", { params });
}